import React from 'react'
import isBehind from './isBehind'
import { ARMFloorIcon } from './ARMFloorIcon';
import ARMFloorTooltip from './ARMFloorTooltip';
import "./ARMFloor.scss";
import {isNullOrUndefined} from "../../../../services/util";

export default function ARMFloor({percentile, metric, grade, firstName, benchmarkName, locale}){

  if(isNullOrUndefined(percentile) || isNullOrUndefined(grade) || !metric){
    return null;
  }

  const behind = isBehind(percentile, metric, grade, locale);
  const tooltipId = `arm-floor-tooltip-${firstName}-${metric}-${benchmarkName}-${grade}-${percentile}`;

  if(behind){
    return (
      <div className="arm-floor behind" data-tip data-for={tooltipId} data-html={true}>
        <ARMFloorIcon />
        <ARMFloorTooltip id={tooltipId} metric={metric} benchmarkName={benchmarkName} firstName={firstName} />
      </div>
    )
  }

  return null;
}